import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'banner',
    (theme, [limitType, limitSize]) => [
      `
			overflow: hidden;
		`,
      limitType &&
        typeof limitSize === 'number' &&
        `
			${limitType}-height: ${limitSize}px;
		`
    ]
  ],
  [
    'image',
    `
		width: 100%;
	`
  ]
]);
